    import React, { useState,useEffect, useCallback} from 'react';
    import api from '../pages/AxiosFetchData';
    import Helper from '../pages/Helper';
    import {  useNavigate} from 'react-router-dom';
    import DialogCustom from './Dialog'
    import DynamicDataGridComponent from './DynamicDataGrid';

    export default function InvoiceDialog({invoiceopen,invoiceclose, id, handleInvoiceDialog}) {
        const [rows, setRows] =  useState([]);
        const Navigate = useNavigate();
      
        useEffect(() => {
            if(invoiceopen) {
                invoiceclose(true);
                GetData();
            }
          
        }, [invoiceopen]);

        const handleClose = () => {
            invoiceclose(false)
        }

        const GetData = useCallback(async () => {
            var response; 
            try{
                response =  await api.get(`getPaymentRak/${id}`).refreshToken(Navigate,"rak",true);
                if(response)
                {
                   setRows(response.data);
                }
            }catch(e){ 
               console.error(e);
            }
        },[id]);

        

        const columns= [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            // { field: 'id', headerName: 'ID.', width: 250, hideable: false},
            { field: 'kode', headerName: 'Inv No.', width: 250 },
            { field: 'payment_date', headerName: 'Invoice Date', width: 100,
                // valueGetter: (value) => {
               // return Helper.GetDateDDMMYYYY(value.row.payment_date);
              // }  
             },
            { field: 'amount', headerName: 'Total', width: 120, valueGetter: (value) => {
                return Helper.formatAsCurrency(value.row.amount);
               }  },
            { field: 'name', headerName: 'Description', width: 200 },
            { field: 'paymentname', headerName: 'Payment method', width: 100 },
            
          {
            field: 'add',
            headerName: '',
            width: 100,
           
            renderCell: (params) => (
              <>
               <button type='button' className='btn btn-info' onClick={(e) => { handleClose(); handleInvoiceDialog(params.row)}} >ADD</button>
              </>
              
            ),
        },
        ];

        return( 
            
            <DialogCustom title="PAYMENT LIST" subtitle={"please select an item from the list below."} open={invoiceopen} onClose={handleClose} maxWidth='md'setOpen={invoiceclose}>
                    <div className='row mb-6'>
                        <div className='col-lg-12'>
                            <DynamicDataGridComponent customcolumns={columns} rows={rows} rowid={"rowNumber"} name="paymentGrid"></DynamicDataGridComponent>
                        </div>
                    </div>
            </DialogCustom>
            
        )
    }
    
    